import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { NamedLinkComponent } from './NamedLinkComponent';
import { RouteNames } from '../../routes/routeConstants';

interface NamedLinkComponentProps {
  name: RouteNames;
  params?: Record<string, any>;
  to?: Record<string, any>;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  activeClassName?: string;
  title?: string;
  target?: string;
  onClick?: () => void;
}
export type NamedLinkProps = RouteComponentProps<any> & NamedLinkComponentProps;

export default withRouter<NamedLinkProps, any>(NamedLinkComponent);
